import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { useInterval } from '@vista-digital/react-tools';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { getCountdownForDate, isExpiredCountdown } from '../../utils/date-utils';
import { padNumberToLength } from '../../utils/pad-number-to-length';
import { DisplayText } from '../display-text';
const b = bemClassBuilder('v-countdown');
const defaultIntervalDelay = 1000;
export const Countdown = observer(props => {
    var _a;
    const [countdown, setCountdown] = useState(getCountdownForDate(props.targetDate));
    const [hasExpired, setHasExpired] = useState(false);
    const delay = hasExpired ? undefined : (_a = props.intervalDelay) !== null && _a !== void 0 ? _a : defaultIntervalDelay;
    useInterval(() => {
        var _a, _b;
        const nextCountdown = getCountdownForDate(props.targetDate);
        setCountdown(nextCountdown);
        (_a = props.onTick) === null || _a === void 0 ? void 0 : _a.call(props);
        if (isExpiredCountdown(nextCountdown)) {
            setHasExpired(true);
            (_b = props.onExpire) === null || _b === void 0 ? void 0 : _b.call(props);
        }
    }, delay);
    return (_jsx(DisplayText, { className: b.block(undefined, props.className), label: props.labelFormat, templateParameters: Object.assign(Object.assign({}, countdown), { seconds: padNumberToLength(countdown.seconds, 2) }) }));
});
Countdown.displayName = 'Countdown';
